import store from "@/state/store";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next("/");
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout", 
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.clear();
        sessionStorage.clear();
        next();
      },
    },
    component: () => import("@/views/account/logout")
  },
  {
    path: "/profile",
    name: "profile",
    meta: {
      title: "Profile", 
      authRequired: true,
      resource: 'Tenant',
      action: 'profile.view',
    },
    component: () => import("@/views/account/profile")
  },
  {
    path: "/profile/edit",
    name: "profile-edit",
    meta: {
      title: "Profile Edit",
      authRequired: true,
      resource: 'Tenant',
      action: 'profile.update',
    },
    component: () => import("@/views/account/profile-setting")
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    meta: {
      title: "Forgot Password",
    },
    component: () => import("@/views/account/forgot-password.vue"),
  },
  {
    path: "/reset-password",
    name: "reset-password",
    meta: {
      title: "Reset Password",
    },
    component: () => import("@/views/account/reset-password.vue"),
  },
];